import React, {
	createContext,
	PropsWithChildren,
	ReactElement,
	ReactNode,
	useContext,
	useEffect,
	useState,
	useRef,
} from 'react'
import SspContext, { deriveisCard } from './SspContext'
import { ITransaction } from 'selfServicePortal/interfaces/i-api-creaditCard'
import getDepositTransactionsService from 'selfServicePortal/services/DepositServices/getDepositTransactionsService'
import getTransactionsService from 'selfServicePortal/services/CreditCardServices/getTransactionsService'

interface ITransactionsContext {
	transactions: ITransaction[] | undefined
	loadingTransactions: boolean
	errorTransactions: boolean
}

const defaultTransactionsContext: ITransactionsContext = {
	transactions: undefined,
	loadingTransactions: true,
	errorTransactions: false,
}
const TransactionsContext = createContext<ITransactionsContext>(
	defaultTransactionsContext,
)

export function TransactionsContextProvider({
	children,
}: PropsWithChildren<ReactNode>): ReactElement {
	const { overviewData, loading, isCard } = useContext(SspContext)
	const [state, setState] = useState<ITransactionsContext>(
		defaultTransactionsContext,
	)
	const ref = useRef<string>()

	useEffect(() => {
		const fetchTransactions = async () => {
			if (loading || !overviewData || !isCard) {
				setState({
					transactions: undefined,
					loadingTransactions: false,
					errorTransactions: true,
				})
				return
			}

			try {
				if (ref.current !== overviewData.accountNumber) {
					if (deriveisCard(overviewData)) {
						const transactions = await getTransactionsService(
							overviewData.accountAgreementId,
							overviewData.transactionDate,
						)
						setState({
							transactions,
							loadingTransactions: false,
							errorTransactions: false,
						})
					} else {
						const transactions =
							await getDepositTransactionsService(
								overviewData.accountAgreementId,
								overviewData.accountAgreementOpenDate,
							)
						setState({
							transactions,
							loadingTransactions: false,
							errorTransactions: false,
						})
					}
				}
			} catch (error) {
				console.warn(error)
				setState({
					transactions: undefined,
					loadingTransactions: false,
					errorTransactions: true,
				})
			}
		}

		fetchTransactions()
		ref.current = overviewData?.accountNumber
	}, [overviewData, loading, isCard])

	return (
		<TransactionsContext.Provider value={state}>
			{children}
		</TransactionsContext.Provider>
	)
}

export default TransactionsContext
